import React from 'react';

import { format } from 'src/lib/format';

interface Props {
  crossedOperationThreshold: number;
}

export const OperationCardinalityExceeded = ({
  crossedOperationThreshold,
}: Props) => (
  // TODO: update this to an Orbit Alert
  <div className="mx-auto flex max-w-lg flex-1 items-center justify-center">
    <div>
      <div className="text-heading-xl mb-6 text-center">
        Operation Cardinality Exceeded
      </div>
      <div className="text-body mb-6 text-center">
        We have detected more than {format.requests(crossedOperationThreshold)}{' '}
        unique operation bodies for your variant. Any additional operations
        beyond these have not been checked and may be affected by this schema
        change.
      </div>
    </div>
  </div>
);
